export interface OriginalCompatTransportLog {
  agent: string;
  projectId: string;
  chapterNumber: number;
  logicalCallId: string;
  requestAccepted: boolean;
  responseParsed: boolean;
  transportAttempts: number;
}

export function logOriginalCompatTransport(entry: OriginalCompatTransportLog): void {
  console.log(`[ORIGINAL COMPAT TRANSPORT] ${JSON.stringify(entry)}`);
}
